import React, { useMemo, useState } from 'react'
import { useContext } from 'react'
import useStep from '../../hooks/use-step'
import { GbsStore } from '../../store'
import { GbsStep } from '../../store/interfaces'
import {
  BeginOnboardingButton,
  FinalQuoteContent,
  FinalQuoteHeader,
  FinalQuoteP,
  ContributionData,
  ContributionLabel,
  EditSelectionLink,
  LearnAboutLink,
  ResourceWrapper,
  SectionTitle
} from './styles'

import { groupService, planService } from '../../services'
import { useQuery } from 'react-query'
import { CostInformation, PlanWrapper } from '../../components/PlanInformation'
import { Resource } from '../../components/Resource'
import { Paths } from '../../routes/paths'
import CompanyNameModal from './CompanyNameModal'
import { Actions } from '../../store/actions'
import { useHistory, Redirect } from 'react-router-dom'
import { CenteredSpinner, useToaster } from 'react-angle-dashboard-components'
import { useStepData } from '../../store/selectors'

const resources = [
  {
    whiteBg: true,
    icon: 'icon-doctor',
    title: 'Find Your Doctor',
    onClick: () => window.open(Paths.publicProviders, '_blank')
  },
  {
    whiteBg: true,
    icon: 'icon-facility',
    title: 'Find Facilities',
    onClick: () => window.open(Paths.publicFacilities, '_blank')
  }
]

const stepKey = 'finalQuote'

export const FinalQuote = () => {
  const history = useHistory()
  const { dispatch } = useContext(GbsStore)
  const { show } = useToaster()
  const { companyName } = useStepData('finalQuote')

  const [showCompanyModal, setShowCompanyModal] = useState(true)
  const [isSaving, setIsSaving] = useState(false)

  const { data: plans } = useQuery(['selectedPlans'], () =>
    planService.getSelectablePlans({ selected: 1 })
  )

  // get cheapest plan total employer premium to determine 'starting at' cost
  const cheapestPlanTotal = plans?.length
    ? plans[plans.length - 1].totalEmployerCost
    : 0

  const stepConfig: Omit<GbsStep, 'data'> = useMemo(() => {
    return {
      bottomBar: {
        hidden: true
      },
      topBar: {
        hidden: true
      }
    }
  }, [])

  useStep(stepKey, stepConfig, dispatch)

  if (companyName) {
    return <Redirect to={Paths.congratulations} />
  }
  return (
    <>
      <CompanyNameModal
        show={showCompanyModal}
        onHide={() => setShowCompanyModal(false)}
        onContinue={async (companyName: string, businessEmail: string) => {
          try {
            setIsSaving(true)
            await groupService.modify({
              group_name: companyName,
              admin_contact_info: {
                work_email: businessEmail
              }
            })
            await groupService.sendLoginEmail()
            dispatch({
              type: Actions.SetStepData,
              payload: {
                stepKey,
                stepData: { companyName }
              }
            })

            const token = sessionStorage.getItem('accessToken')
            if (token) localStorage.setItem('accessToken', token)

            setIsSaving(false)
            history.push(Paths.congratulations)
          } catch (error: any) {
            setIsSaving(false)
            show({
              message:
                error.message ||
                'Failed to save company name, please try again later or contact our support team',
              type: 'danger'
            })
          }
        }}
      />
      {isSaving ? (
        <CenteredSpinner />
      ) : (
        <>
          <FinalQuoteHeader>
            <h1 className="text-white">Congratulations!</h1>
          </FinalQuoteHeader>
          <FinalQuoteContent>
            <FinalQuoteP>
              We’ve estimated your costs and benefits based on your plan
              selection(s) and employee information. You’re ready to begin
              onboarding and enrollment!
            </FinalQuoteP>
            <SectionTitle>Your total employer contribution</SectionTitle>
            <div>
              <div>
                <ContributionLabel>Estimated</ContributionLabel>
                <ContributionData style={{ fontSize: 45 }}>
                  $<span>{cheapestPlanTotal}</span>/mo
                </ContributionData>
              </div>
              {/* TODO: need this breakdown on backend */}
              {/* <div>
            <ContributionLabel>Employees</ContributionLabel>
            <ContributionData>$3,100</ContributionData>
          </div>
          <div>
            <ContributionLabel>Dependents</ContributionLabel>
            <ContributionData>$1,027</ContributionData>
          </div> */}
            </div>
            <BeginOnboardingButton>Begin Onboarding</BeginOnboardingButton>
            <LearnAboutLink to={Paths.finalQuoteDetails}>
              Learn About My Plan Details
            </LearnAboutLink>
            <div className="d-flex justify-content-center flex-wrap">
              {plans?.map((plan) => (
                <PlanWrapper
                  style={{ height: 525, marginRight: 30 }}
                  key={plan.id}
                >
                  <CostInformation
                    plan={plan}
                    compressedVersion
                    onShowPlanDetails={(id: string) => {}}
                  />
                </PlanWrapper>
              ))}
            </div>
            <EditSelectionLink to="/plans" className="mt-3 mb-4">
              Edit My Plan Selection
            </EditSelectionLink>
            <SectionTitle>Resources</SectionTitle>
            <div className="d-flex justify-content-center flex-wrap">
              {resources.map((resource) => (
                <ResourceWrapper key={resource.title}>
                  <Resource {...resource} />
                </ResourceWrapper>
              ))}
            </div>
          </FinalQuoteContent>
        </>
      )}
    </>
  )
}

export default FinalQuote
